module.exports = __webpack_public_path__ + "img/inside_banner_float.d506f2b.png";